import { render, staticRenderFns } from "./DepositOverview.vue?vue&type=template&id=978e6dee&"
import script from "./DepositOverview.vue?vue&type=script&lang=js&"
export * from "./DepositOverview.vue?vue&type=script&lang=js&"
import style0 from "./DepositOverview.vue?vue&type=style&index=0&id=978e6dee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports